//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import iconClose from '@/assets/icon/itemDetail/gift_share_ic_close_normal@2x.png'
import MomentShare from '@/components/MomentShare'
import FbShare from '@/components/FbShare'
import LineShare from '@/components/LineShare'
import copyButton from '@/components/copyButton'
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    image: {
      type: String
    },
    title: {
      type: String
    },
    desc: {
      type: String,
      default: ''
    },
    nickname: {
      type: String,
      default: ''
    },
    shareSuc: {
      type: Function
    },
    url: {
      type: String
    },
    isCover: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    left: {
      type: Number
    },
    objectId: {
      type: Number
    },
    showMoment: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: ''
    },
    showCopy: {
      type: Boolean,
      default: false
    },
    showFB: {
      type: Boolean,
      default: true
    }
  },
  components: {
    FbShare,
    LineShare,
    MomentShare,
    copyButton
  },
  data () {
    return {
      iconClose
    }
  },
  methods: {
    // 显示菜单
    hideShareBar () {
      this.$emit('hideShareBar')
    }
  }
}
